import { useState } from "react";

import { Button, Grid2, Typography } from "@mui/material";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

import { apis, callApi } from "../../../api";
import useScreenSize from "../../../hooks/useScreenSize";
import { rules } from "../../../utils";
import { CommonInput } from "../../common";
import { Container } from "../../common/Container/Container";

import "./reset_password.scss";

export type TResetPasswordFieldValues = {
	email: string;
	password: string;
	confirmPassword: string;
};

export function ResetPassword() {
	const params = useParams();
	const token = params.token;

	const { control, handleSubmit } = useForm<TResetPasswordFieldValues>({
		defaultValues: {
			email: "",
			password: "",
			confirmPassword: "",
		},
		mode: "onChange",
	});

	const [isTokenInvalid, setIsTokenInvalid] = useState(false);

	const navigate = useNavigate();

	const { width } = useScreenSize();
	const isMobile = width <= 768;

	const onClickResetPassword = async (data: TResetPasswordFieldValues) => {
		try {
			const { email, password } = data;

			await callApi({
				method: "POST",
				url: apis.RESET_PASSWORD,
				body: {
					email,
					password,
					serviceToken: token,
				},
			});

			toast.success("Reset password successfully, now you can sign in again!");
			navigate("/sign-in", { replace: true });
		} catch (error: any) {
			if (error?.response?.status === 404) {
				if (error.response.data?.message === "User not found") {
					alert("This account does not exist!");
					return;
				}

				if (error.response.data?.message === "Invalid or Expired Token") {
					setIsTokenInvalid(true);
					return;
				}
			}
			alert("Something went wrong, please try again later!");
		}
	};

	if (isTokenInvalid) {
		return (
			<center>
				<h4>
					Reset password token is invalid, now you can safely close this window!
				</h4>
			</center>
		);
	}

	return (
		<Container className="reset-password-container">
			<Grid2 container>
				<Grid2 size={{ xs: 12, sm: 12, md: 4, lg: 4, xl: 4 }}>
					<form
						className="reset-password-form"
						onSubmit={handleSubmit(onClickResetPassword)}>
						<Typography className="reset-password-text">
							RESET PASSWORD
						</Typography>
						<CommonInput
							control={control}
							name="email"
							type="email"
							placeholder="Email"
							rules={{
								required: {
									value: true,
									message: "Email is required.",
								},
								pattern: rules.email.pattern,
							}}
						/>
						<CommonInput
							control={control}
							name="password"
							type="password"
							placeholder="Password*"
							rules={{
								required: {
									value: true,
									message: "Password is required.",
								},
								pattern: rules.password.pattern,
							}}
						/>
						<CommonInput
							control={control}
							name="confirmPassword"
							type="password"
							placeholder="Confirm password*"
							rules={{
								required: {
									value: true,
									message: "Confirm password is required.",
								},
								pattern: rules.password.pattern,
								validate: (value, formValues) => {
									if (value === formValues.password) {
										// It must return undefined; or return; here
										return;
									}
									return "Confirm password is not match.";
								},
							}}
						/>

						<Button
							className="normal-button primary-button reset-password-button"
							type="submit">
							Reset password
						</Button>
					</form>
				</Grid2>

				{!isMobile && (
					<Grid2 size={{ md: 8, lg: 8, xl: 8 }}>
						<div style={{ display: "flex", justifyContent: "flex-end" }}>
							<img
								src={require("../../imagenes/botones2.png")}
								alt="botones2"
								style={{ width: "91.667%" }}
							/>
						</div>
					</Grid2>
				)}
			</Grid2>
		</Container>
	);
}
